module.exports = __webpack_public_path__ + "media/logos/Jimmy Choo 1-632ba075.svg";